import { render, staticRenderFns } from "./ParagraphView.vue?vue&type=template&id=427c650e"
import script from "./ParagraphView.vue?vue&type=script&lang=js"
export * from "./ParagraphView.vue?vue&type=script&lang=js"
import style0 from "./ParagraphView.vue?vue&type=style&index=0&id=427c650e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports